const USER_INDEX_TABS = {
  SCENARIOS: 'featured-scenarios',
  CHARACTERS: 'characters'
};

const USER_INDEX_MODES = {
  PUBLIC: 'public',
  PRIVATE: 'private'
};

const PUBLIC_SCENARIO_TABS = {
  ACTIVE: 'active',
  ARCHIVE: 'archive'
};

export { USER_INDEX_TABS, USER_INDEX_MODES, PUBLIC_SCENARIO_TABS };
